import { Variant } from 'components/functions/offerListFunctions/saleOfferListFunctions/saleOfferListFunctions';

export const calculateMinElementWidth = (
    value: string | number | undefined,
    predictedValue: string | number | undefined,
    prefix?: string,
    suffix?: string,
    variant?: Variant
): number | null => {
    if (variant !== 'different' || value === undefined || predictedValue === undefined) return null;

    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');

    if (!context) return null;

    const font = '500 italic 14px Poppins, sans-serif';
    context.font = font;

    const fullValue = `${prefix ?? ''}${value}${suffix ?? ''}`;
    const fullPredicted = `${prefix ?? ''}${predictedValue}${suffix ?? ''}`;

    const textWidth = Math.max(context.measureText(fullValue).width, context.measureText(fullPredicted).width);

    const PADDING_LEFT_RIGHT = 12;
    const GAP_BETWEEN_ELEMENTS = 6;
    const ICON_WIDTH = 20;
    const EXTRA_MARGIN = 14;
    const ADDITIONAL_WIDTH = PADDING_LEFT_RIGHT + GAP_BETWEEN_ELEMENTS + ICON_WIDTH + EXTRA_MARGIN;

    const minWidth = Math.ceil(textWidth) + ADDITIONAL_WIDTH;

    return minWidth;
};
